// extracted by mini-css-extract-plugin
export default {"message":"ClearPersonsConfirmationModal__message___E02wA"};